module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2f"
  }, [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _c('a', {
    attrs: {
      "id": "ill"
    }
  }), _vm._v("ILLUSTRATIONS")]), _vm._v(" "), _c('p', {
    staticClass: "toc5"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/fm#fig1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("With President Barack Obama")])]), _vm._v(" "), _c('p', {
    staticClass: "toc5"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter01#fig2"
    }
  }, [_vm._v("With President Bill Clinton, Reverend Jesse Jackson, and Senator Ernest “Fritz” Hollings, 1996")])]), _vm._v(" "), _c('p', {
    staticClass: "toc5"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter01#fig3"
    }
  }, [_vm._v("With Senator Hillary Clinton and Mayor Joe Riley, 2007")])]), _vm._v(" "), _c('p', {
    staticClass: "toc5"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter01#fig4"
    }
  }, [_vm._v("With Senator Barack Obama, 2007")])]), _vm._v(" "), _c('p', {
    staticClass: "toc5"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter01#fig5"
    }
  }, [_vm._v("With Mary Steenburgen, Congresswoman Stephanie Tubbs Jones, and Ted Danson")])]), _vm._v(" "), _c('p', {
    staticClass: "toc5"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter02#fig6"
    }
  }, [_vm._v("With Shirley Chisholm, 1978")])]), _vm._v(" "), _c('p', {
    staticClass: "toc5"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter03#fig7"
    }
  }, [_vm._v("John Dizzley")])]), _vm._v(" "), _c('p', {
    staticClass: "toc5"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter03#fig8"
    }
  }, [_vm._v("Phoebe Lloyd Clyburn, circa 1890")])]), _vm._v(" "), _c('p', {
    staticClass: "toc5"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter03#fig9"
    }
  }, [_vm._v("The Reverend Enos Lloyd Clyburn, circa 1950")])]), _vm._v(" "), _c('p', {
    staticClass: "toc5"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter04#fig10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Almeta Dizzley Clyburn, circa 1968")])]), _vm._v(" "), _c('p', {
    staticClass: "toc5"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter04#fig11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("With parents and brothers, John and Charles, 1964")])]), _vm._v(" "), _c('p', {
    staticClass: "toc5"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter05#fig12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("With John and Charles Clyburn, 2010")])]), _vm._v(" "), _c('p', {
    staticClass: "toc5"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter06#fig13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Reverend Isaiah DeQuincey Newman")])]), _vm._v(" "), _c('p', {
    staticClass: "toc5"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter06#fig14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("With James Gilliard, Clarence “Duke” Missouri, and Bobby Doctor, 2012")])]), _vm._v(" "), _c('p', {
    staticClass: "toc5"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter07#fig15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("With Emma Wilder, “Duke” Missouri, and Rosemary Bland, 1957")])]), _vm._v(" "), _c('p', {
    staticClass: "toc5"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter08#fig16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("In a production of "), _c('em', [_vm._v("Julius Caesar")]), _vm._v(" at S.C. State")])]), _vm._v(" "), _c('p', {
    staticClass: "toc5"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter08#fig17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("With Emily on our wedding day, June 24, 1961")])]), _vm._v(" "), _c('p', {
    staticClass: "toc5"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter09#fig18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("With the Corsairs club at C. A. Brown High School")])]), _vm._v(" "), _c('p', {
    staticClass: "toc5"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter09#fig19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("With Ambassador James Gadsden, 2002")])]), _vm._v(" "), _c('p', {
    staticClass: "toc5"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter10#fig20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("With Laura Martinez and two Talent Search students leaving Charleston to attend Wilberforce University, 1967")])]), _vm._v(" "), _c('p', {
    staticClass: "toc5"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter11#fig21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("With Senator Hollings")])]), _vm._v(" "), _c('p', {
    staticClass: "toc5"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter11#fig22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("With University of South Carolina president Harris Pastides, and Bud Ferillo, 2012")])]), _vm._v(" "), _c('p', {
    staticClass: "toc5"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter12#fig23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("With Lieutenant Governor Earle Morris, Governor John West, and fellow aide Phil Grose, 1971")])]), _vm._v(" "), _c('p', {
    staticClass: "toc5"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter12#fig24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Speaking at the unveiling of the Mary McLeod Bethune portrait in the South Carolina State House")])]), _vm._v(" "), _c('p', {
    staticClass: "toc5"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter13#fig25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("With Governor Jim Edwards, 1970s")])]), _vm._v(" "), _c('p', {
    staticClass: "toc5"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter13#fig26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("With the Human Affairs staff")])]), _vm._v(" "), _c('p', {
    staticClass: "toc5"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter17#fig27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("With Dr. King at a rally in Charleston, 1967")])]), _vm._v(" "), _c('p', {
    staticClass: "toc5"
  }, [_c('a', {
    attrs: {
      "id": "page_x"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter18#fig28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Clyburn family, circa 1974")])]), _vm._v(" "), _c('p', {
    staticClass: "toc5"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter22#fig29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("With Ruth and Carole Smith")])]), _vm._v(" "), _c('p', {
    staticClass: "toc5"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter22#fig30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("First Tee golf group in Columbia")])]), _vm._v(" "), _c('p', {
    staticClass: "toc5"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter24#fig31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("With Bill DeLoach, Speaker of the House Thomas Foley, and Emily Clyburn, 1993")])]), _vm._v(" "), _c('p', {
    staticClass: "toc5"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter24#fig32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ceremonial swearing-in at the South Carolina State House for the state’s 1993 congressional delegation")])]), _vm._v(" "), _c('p', {
    staticClass: "toc5"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter24#fig33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("With former governor and U.S. ambassador to Saudi Arabia John West, 1993")])]), _vm._v(" "), _c('p', {
    staticClass: "toc5"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter25#fig34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("With fellow congressmen Earl Hilliard and Bennie Thompson, 1999")])]), _vm._v(" "), _c('p', {
    staticClass: "toc5"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter26#fig35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Shaking hands with Judge Matthew J. Perry Jr.")])]), _vm._v(" "), _c('p', {
    staticClass: "toc5"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter26#fig36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("At the dedication of the Matthew J. Perry Courthouse")])]), _vm._v(" "), _c('p', {
    staticClass: "toc5"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter27#fig37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("With President Bill Clinton and fellow members of the Congressional Black Caucus, 1999")])]), _vm._v(" "), _c('p', {
    staticClass: "toc5"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter27#fig38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("With two former House majority whips, Bill Gray and Roy Blunt on the day I became majority whip, 2007")])]), _vm._v(" "), _c('p', {
    staticClass: "toc5"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter28#fig39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("With Judge Richard Fields, 2011")])]), _vm._v(" "), _c('p', {
    staticClass: "toc5"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter29#fig40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("With Claflin University president Henry Tisdale and House minority leader Dick Gephardt")])]), _vm._v(" "), _c('p', {
    staticClass: "toc5"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter29#fig41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("With Speaker Nancy Pelosi and my family")])]), _vm._v(" "), _c('p', {
    staticClass: "toc5"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter29#fig42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Building relationships at the 2012 RBC Heritage Pro-Am")])]), _vm._v(" "), _c('p', {
    staticClass: "toc5"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter30#fig43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Celebrating the Honda Accord with Governor Beasley")])]), _vm._v(" "), _c('p', {
    staticClass: "toc5"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter31#fig44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Leading the Congressional Procession at President Obama’s 2009 Inauguration")])]), _vm._v(" "), _c('p', {
    staticClass: "toc5"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter31#fig45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("With my daughters at the march to remove the Confederate flag from the state capitol")])]), _vm._v(" "), _c('p', {
    staticClass: "toc5"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter32#fig46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("At the first 2007 Democratic Presidential Debate, held at South Carolina State University, with presidential hopefuls Mike Gravel, Barack Obama, Chris Dodd, John Edwards, Dennis Kucinich, Joe Biden, Bill Richardson, and Hillary Clinton")])]), _vm._v(" "), _c('p', {
    staticClass: "toc5"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter33#fig47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The extended Clyburn family at the dedication of the James E. Clyburn Research Center at the Medical University of South Carolina, 2011")])]), _vm._v(" "), _c('p', {
    staticClass: "toc5"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter33#fig48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("With Assistant to the Speaker Chris Van Hollen, Speaker of the House Nancy Pelosi, President Barack Obama, Majority Leader Steny Hoyer, Democratic Caucus Chair John Larson, and Democratic Caucus Vice Chair Xavier Becerra, 2009")])]), _vm._v(" "), _c('p', {
    staticClass: "toc5"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter34#fig49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("With Congressmen Bennie Thompson and Cedric Richmond")])]), _vm._v(" "), _c('p', {
    staticClass: "toc5"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter35#fig50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Clyburn family in 2011")])]), _vm._v(" "), _c('p', {
    staticClass: "toc5"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/epilogue#fig51",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Clyburns at the awarding of Reverend E. L. Clyburn’s posthumous degree from Morris College, 2003")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-72c09cb5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/illustrations.vue
// module id = 78
// module chunks = 0